import { Index } from '@modules/missions/keaz/step'

export function KeazStep() {
  return <Index />
}
